import React from 'react';
import {
  People as PeopleIcon,
  Description as DescriptionIcon,
  BarChart as BarChartIcon,
  CloudQueue as CloudQueueIcon,
  Apartment as ApartmentIcon,
} from '@material-ui/icons';
import { GuarantorsPropertiesText } from 'screens/GuarantorsScreen/components';
import { ru } from 'locale';

export const categories = [
  {
    id: 'gp',
    label: <GuarantorsPropertiesText />,
    icon: PeopleIcon,
  },
  {
    id: 'sb-report',
    label: ru.reportSb,
    icon: DescriptionIcon,
  },
  {
    id: 'sd-analytics',
    label: ru.sdAnalytics,
    icon: BarChartIcon,
  },
  {
    id: 'kf-analytics',
    label: ru.kfAnalytics,
    icon: CloudQueueIcon,
  },
  {
    id: 'objects',
    label: ru.objects,
    icon: ApartmentIcon,
  },
];

export const permissionAccessCategories = ['sbreport'];
